<template>
  <div>

    <b-row class="match-height">
      <b-col
        xl="8"
        lg="8"
        md="12"
      >
        <b-card no-body>
          <b-card-header class="border-bottom mb-2">
            <h4 class="mb-0">
              Device Details
            </h4>
            <b-card-text>
              <b-button
                variant="outline-primary"
                @click="$refs.editSiteModal.show()"
              >Edit</b-button>
            </b-card-text>
          </b-card-header>
          <b-card-body>
            <b-row class="mb-2">

              <b-col>
                <p><b>ID:</b></p>
                <kbd>{{ site.id }}</kbd>
              </b-col>

              <b-col>
                <p> <b>Name</b></p>
                <kbd>{{ site.name }}</kbd>
              </b-col>

            </b-row>

            <b-row class="border-bottom mb-2">
              <b-col>
                <h4>Location</h4>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <p>
                  <b>Address</b>
                </p>
                <kbd> {{ site.address }} </kbd>
              </b-col>

              <b-col>
                <p>
                  <b>Zip Code</b>
                </p>
                <kbd>
                  {{ site.zip_code }}
                </kbd>
              </b-col>

              <b-col>
                <p>
                  <b>City</b>
                </p>
                <kbd>
                  {{ site.city }}
                </kbd>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col>
                <p>
                  <b>Sub Region</b>
                </p>
                <kbd>
                  {{ site.subRegion }}
                </kbd>
              </b-col>

              <b-col>
                <p>
                  <b>Region</b>
                </p>
                <kbd>
                  {{ site.region }}
                </kbd>
              </b-col>

              <b-col>
                <p>
                  <b>Country</b>
                </p>
                <kbd>
                  {{ site.country }}
                </kbd>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col
        xl="4"
        lg="4"
        md="12"
        sm="12"
      >
        <b-card
          no-body
        >
          <site-map
            :coordinates="JSON.parse(site.AWSLongLat)"
          />
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col
        xl="12"
        lg="12"
        md="12"
        sm="12"
      >
        <site-objects
          :site-info="site"
        />
      </b-col>
    </b-row>

    <b-modal
      id="editDeviceModal"
      ref="editSiteModal"
      title="Edit Site"
      ok-title="Save"
      cancel-variant="outline-primary"
      ok-variant="primary"
      @ok="$emit('saveSiteDetails', site)"
      @cancel="$emit('cancel')"
    >
      <b-form-group
        label="Name"
        label-for="name"
      >
        <b-form-input
          id="name"
          v-model="site.name"
          required
          placeholder="Enter name"
        />
      </b-form-group>

      <b-form-group
        label="Address"
        label-for="address"
      >
        <b-form-input
          id="address"
          v-model="site.address"
          required
          placeholder="Enter address"
        />
      </b-form-group>

      <b-form-group
        label="Zip Code"
        label-for="zipCode"
      >
        <b-form-input
          id="zipCode"
          v-model="site.zip_code"
          required
          placeholder="Enter zip code"
        />
      </b-form-group>

      <b-form-group
        label="City"
        label-for="city"
      >
        <b-form-input
          id="city"
          v-model="site.city"
          required
          placeholder="Enter city"
        />
      </b-form-group>

      <b-form-group
        label="Sub Region"
        label-for="subRegion"
      >
        <b-form-input
          id="subRegion"
          v-model="site.subRegion"
          required
          placeholder="Enter sub region"
        />
      </b-form-group>

      <b-form-group
        label="Region"
        label-for="region"
      >
        <b-form-input
          id="region"
          v-model="site.region"
          required
          placeholder="Enter region"
        />
      </b-form-group>

      <b-form-group
        label="Country"
        label-for="country"
      >
        <b-form-input
          id="country"
          v-model="site.country"
          required
          placeholder="Enter country"
        />
      </b-form-group>

      <b-form-group
        label="AWS Long Lat"
        label-for="AWSLongLat"
      >
        <b-form-input
          id="AWSLongLat"
          v-model="site.AWSLongLat"
          required
          placeholder="Enter AWS Long Lat"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BCardText,
  BButton,
  BModal,
  BFormInput,
  BFormGroup,
} from 'bootstrap-vue'
import SiteMap from './SiteMap.vue'
import SiteObjects from './SiteObjects.vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardText,
    BRow,
    BCol,
    BButton,
    BModal,
    BFormInput,
    BFormGroup,
    SiteMap,
    SiteObjects,
  },
  props: {
    site: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style>

</style>
